module.exports = __webpack_public_path__ + "img/img-17.6f9ee48a.svg";